import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService'
import { liabilityLimitPretty } from '../../../../services/utils'
import { isMobile,MobileView,BrowserView } from 'react-device-detect'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as LiabilityShield } from '../../../../assets/liability_shield.svg'
import { RadioGroup, FormControlLabel, Radio, Dialog, Divider, Checkbox ,TextField,MenuItem} from '@material-ui/core'
import PolicyLiabilityExtensionContext, { PolicyLiabilityExtensionContextStore, ACTIONS } from '../../../../context/PolicyLiabilityExtensionContext'
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame'
import { ElevatedCircle } from '../../../Core/ElevatedCircle'
import { Action } from '../../../../models/Action'
import { GreenButton } from '../../../Core/Buttons/GreenButton'
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService'
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog'
import { InsuranceTypes } from '../../../../models/insurance-models/InsuranceBillingPeriodModel';
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import { ModificationContextStore } from '../../../../context/ModificationContext'
import { SUBSCRIPTION_STATE } from '../../../../models/insurance-models/PolicySubscriptionState'
import {SessionContextStore} from '../../../../context/SessionContext';
import { LiabilityCoveragePopover } from '../../../Core/Popover/LiabilityCoveragePopover'
import { SessionService } from '../../../../services/SessionService';

var classNames = require('classnames')

interface LiabilitySectionProps {
    insurance: ActiveInsuranceModel
}
export const LiabilityExtensionManage = ({...props}) => {
    const liabilityExtensionContext = useContext(PolicyLiabilityExtensionContextStore)
    const policyRenewalContext = useContext(PolicyRenewalContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const modificationContext = React.useContext(ModificationContextStore)  
    const {insurance, modify,isRenewal,modificationObject} = props;
    const modifyOptions = isRenewal ? modificationContext.liabilityLimitOptions?.modify_subscription_options : modificationContext.liabilityLimitOptions?.midterm_options
    const [selectedOffer, setSelectedOffer] = React.useState( 
            policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? {
                liabilityLimit: insurance.liabilityLimit,
                finalCost: 0,
            } : liabilityExtensionContext.offers.find(l => l.liabilityLimit == insurance.subscription.liabilityLimit))

    const [additionalCost, setAdditionalCost] = React.useState(0)

    const chooseOffer = (offer) => {
        setSelectedOffer(offer)
            if(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT)
                setAdditionalCost(offer.finalCost)
            else
                setAdditionalCost(offer.finalCost - liabilityExtensionContext.offers.find(l => l.liabilityLimit == insurance.subscription.liabilityLimit).finalCost)
    }

    const onLiabilityChange = (e) => {
        if(modify){
            const option = modifyOptions.find(l => l.liability_limit == Number(e.target.value))
                modificationContext.setLiabilityLimit(Number(e.target.value),isRenewal)
        }
        else{
            let offer = (liabilityExtensionContext.offers.find(l => l.liabilityLimit == e.target.value))
            if(offer) {
                if(offer.commercial && !sessionContext.user.commercial) {
                    EventEmitterService.dispatch(EventKey.SHOW_COMMERCIAL_POPUP, {liabilityLimit: offer.liabilityLimit, drones: !isRenewal ? modificationContext.insurance.drones : [], equipment: !isRenewal ? modificationContext.insurance.equipment : [] })
                    EventEmitterService.once(EventKey.USER_ACCEPT_COMMERCIAL, () => {
                        chooseOffer(offer);
                    })
                }
                else {
                    chooseOffer(offer);
                }
        }
        else if(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT) {
            setSelectedOffer({
                liabilityLimit: insurance.liabilityLimit,
                finalCost: 0,
            })
            setAdditionalCost(0)
        }
        }
        
    }

    const applyLiabilityExtension = () => {
        if(selectedOffer.finalCost == 0) return

        liabilityExtensionContext.purchaseLiabilityExtension(selectedOffer)
    }

    return (<>
            <FlexView column>
            <div className="text-small gray margin-top-basic">The maximum amount of money paid for bodily injury/property damage in the event of a claim</div>
            <MobileView>
                <TextField select size="small" InputProps={{ disableUnderline: true, className: 'lightgrayblue'}} className="margin-top-basic" variant="outlined" fullWidth value ={modificationObject.liabilityLimit}
                    onChange={onLiabilityChange} value={modify? modificationObject.liabilityLimit : selectedOffer.liabilityLimit}
                    disabled= {(SessionService.isAdmin()? false : sessionContext.user.liabilityLimitAllow !== 10000000 )|| (isRenewal ? insurance.subscription.isLiabilitySpecialPrice : insurance.isLiabilitySpecialPrice)}
                >
                    {modifyOptions?.map(option =>
                        <MenuItem
                            className="radio-liability"
                            key={option.liability_limit} 
                            value={option.liability_limit} 
                        >
                            {liabilityLimitPretty(option.liability_limit)}
                        </MenuItem>
                    )}
                </TextField>
            </MobileView>
            
            <BrowserView>
            <RadioGroup className="margin-top-basic" 
                value={modify ? modificationObject.liabilityLimit : selectedOffer.liabilityLimit} 
                onChange={onLiabilityChange}>
                <FlexView className="space-evenly">
                    {modify ? 
                        modifyOptions?.map(option => 
                        <FormControlLabel 
                        disabled= {(SessionService.isAdmin()? false : sessionContext.user.liabilityLimitAllow !== 10000000 )|| (isRenewal ? insurance.subscription.isLiabilitySpecialPrice : insurance.isLiabilitySpecialPrice)}
                        key={option.liability_limit} 
                            value={option.liability_limit} 
                            control={<Radio  color="primary" />}
                            label={<div 
                                className={classNames("text-small", 
                                    {"blue bold": (modify && modificationObject.liabilityLimit == option.liabilityLimit)})}>
                                    {liabilityLimitPretty(option.liability_limit)}
                                </div>} />
                    )
                    :
                    liabilityExtensionContext.offers?.map(option => 
                        <FormControlLabel 
                            key={option.liabilityLimit} 
                            value={option.liabilityLimit} 
                            control={<Radio  color="primary" />}
                            label={<div 
                                className={classNames("text-small", 
                                    {"blue bold": (modify && modificationObject.liabilityLimit == option.liabilityLimit) || insurance.subscription.liabilityLimit == option.liabilityLimit })}>
                                    {liabilityLimitPretty(option.liabilityLimit)}
                                </div>} />
                        )
                    }
                    
                </FlexView>
            </RadioGroup>
            </BrowserView>
            </FlexView>
            {!modify && <FlexView column={isMobile} vAlignContent={'center'} className="space-between margin-bottom-basic">
                {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 
                    <div className="text-small black">This change will be effective immediately</div>
                : 
                    <div className="text-small black">This change will be effective on your next billing date</div>}
            </FlexView>}
            <FlexView column hAlignContent={'center'}>
                {additionalCost > 0 && (
                    policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ?
                        <div className="text-small bold blue margin-top-basic margin-bottom-basic">You will be charged an additional {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{additionalCost.toLocaleStringToFixed()}</div> 
                    :
                        <div className="text-small bold blue margin-top-basic margin-bottom-basic">Your policy renewal cost will be an additional {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{additionalCost.toLocaleStringToFixed()}</div> 
                )}
                {!modify &&<div className="margin-bottom-small"><GreenButton disabled={additionalCost == 0} onClick={applyLiabilityExtension}>Update Liability</GreenButton></div>}
            </FlexView>
        </>
    )
}

export const LiabilitySection = ({insurance, modify=false, isRenewal= false}: LiabilitySectionProps) => {
    const [open, setOpen] = useState(false)
    const policyRenewalContext = useContext(PolicyRenewalContextStore)
    const openDialog = () => {
        setOpen(true)
    }

    const closeDialog = () => {
        setOpen(false)
    }

    const getRenewalOffer = () => policyRenewalContext.renewalOffers.find( l => l.liabilityLimit == insurance.subscription.liabilityLimit)

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, closeDialog);

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, id)
        }
    }, [])

    return (<>
            <FlexView className="space-between margin-bottom-basic">
                <div className="text-body bold black">Liability Coverage <LiabilityCoveragePopover/></div>
                {insurance.isActiveOrSchedule() &&
                     FirebaseService.getBoolean(FirebaseConfigKey.LIABILTY_LIMIT_EXTENSION_AVAILABLE) &&
                     insurance.insuranceType != InsuranceTypes.HOURLY}
            </FlexView>
            <FlexView column={isMobile} className={classNames({"space-between": !isMobile} ,"margin-top-small")}>
                <div className="black text-small">
                    {liabilityLimitPretty(policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT 
                        ? insurance.liabilityLimit : insurance.subscription.liabilityLimit)} Liability limit
                </div>
                <div className="gray margin-top-small text-tiny">
                    Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}
                    {policyRenewalContext.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT ? 
                        insurance.totalLiabilityPremium.toLocaleStringToFixed() : insurance.subscription.liabilityLimitPremium.toLocaleStringToFixed()}   
                        <br/>
                    {(SessionService.isAdmin() && ((insurance.isLiabilitySpecialPrice && !isRenewal) || (isRenewal && insurance.subscription.isLiabilitySpecialPrice))) && <div className="gray margin-top-small text-tiny">*Special Price</div>}
                        </div>
            </FlexView>
                <SkywatchDialog
                    open={open}
                    closeDialog={closeDialog}
                    circleHeader={<ElevatedCircle> <LiabilityShield className="medium-icon" /></ElevatedCircle>}
                    closeTitle="Liability Coverage"
                    maxWidth={'sm'}>
                        <LiabilityExtensionManage modify={modify} insurance={insurance} />
                </SkywatchDialog>
        </>
    )
}